import React from "react";
import { useIntl } from "react-intl";

/*
    Account Icon
    props:
        - title: string, override the default title 'Account'
        - color: string, override the default color '#00549A' (bell blue)
*/

const DeleteIcon = (props) => {
    const intl = useIntl();
    return (
        <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>{props.title || (intl.locale == "en" ? "Delete" : "Effacer")}</title>
            <path
                d="M4.23535 6.66179H19.7647M10.0588 11.0294V16.8529M13.9412 11.0294V16.8529M6.17655 6.6618H17.8236V20.25H6.17655V6.6618ZM9.08824 3.75H14.9118V6.66176H9.08824V3.75Z"
                stroke={props.color || "#00549A"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DeleteIcon;
